import React from 'react';

import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { SCPayoutCriteriaDetail, payqualifiersFormat } from '../scorecardPayoutCriteria/scorecard-payout-criteria-service';
import ApprovedIcon from '../../../assets/DisputeReviewedIcon.svg';
import DisputedIcon from '../../../assets/DisputedIcon.svg';
import { Numbers } from '../../../utils/typeConstants';

interface SCPayoutCriteriaDetailsProps {
    payoutCriteriaDetail: SCPayoutCriteriaDetail;
}
export const SCPayoutCriteriaDetails = ({ payoutCriteriaDetail }: SCPayoutCriteriaDetailsProps) => {
    if (payoutCriteriaDetail) {
        return (
            <div className="card mt-3 border-0">
                <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '15px' }}>
                    Payout Details
                </div>
                <div className="card-body tableContentCardBody">
                    <div className='row'>
                        <div className='col-md-4 border-end padding-0-40'>
                            <div className='row'>
                                <div className='col-md-12'>   <strong>Result</strong></div>
                                {payoutCriteriaDetail.eligible && <div className='flex-display'><img src={ApprovedIcon} className='height-20' alt='Yes' /> <div className='col-md-12 font-weight-100 m-10-left'>Eligible Yes</div></div>}
                                {!payoutCriteriaDetail.eligible && <div className='flex-display'><img src={DisputedIcon} className='height-20' alt='No' /> <div className='col-md-12 font-weight-100 m-10-left'>Eligible No</div></div>}
                            </div>
                            <div className='row m-t-20 '>
                                <div className='col-md-12 text-italic'>Qualifiers</div>
                                <hr />
                                {payoutCriteriaDetail.pay_qualifiers.length > 0 &&
                                    payoutCriteriaDetail.pay_qualifiers.map((qualifier: any) => (
                                        <div className='col-md-4'>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="qualifier-label">
                                                    {qualifier.pay_qualifier_type_name}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="qualifier-value">
                                                {payqualifiersFormat(qualifier.pay_qualifier_value,qualifier.metric_type_name )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    ))
                                }
                                {
                                    payoutCriteriaDetail.pay_qualifiers.length === 0 && <div className='col-md-12'>No Qualifiers</div>
                                }
                            </div>
                        </div>
                        <div className='col-md-6  border-end padding-0-40'>
                            <div className="row">
                                {[
                                    {
                                        label: 'Regular Hours',
                                        value: payoutCriteriaDetail?.regular_hours ?? '--',
                                    },
                                    {
                                        label: 'Payout Tenure Name',
                                        value: payoutCriteriaDetail?.payout_tenure_name ?? '--',
                                    },
                                    {
                                        label: 'Percentage Payout',
                                        value: (payoutCriteriaDetail?.payout_percentage !== undefined) ? `${(payoutCriteriaDetail.payout_percentage * 100).toFixed(Numbers.TWO)}%` : '--',
                                    },
                                    {
                                        label: 'Glidepath Month',
                                        value: payoutCriteriaDetail?.glidepath_month ?? '--',
                                        border: true,
                                    },
        
                                    {
                                        label: 'OT Hours',
                                        value: payoutCriteriaDetail?.ot_hours ?? '--',
                                    },
                                    {
                                        label: 'Pay Basis',
                                        value: payoutCriteriaDetail?.pay_basis ?? '--',
                                    },
                                    {
                                        label: 'Payout Rule Name',
                                        value: payoutCriteriaDetail?.pay_rule_name ?? '--',
                                    },
                                ].map((item) => (
                                   <div className="col-md-3 padding-5" key={item.label}>
                                        <div className="row">
                                            <div className="qualifier-label col-md-12">
                                                <strong>{item.label}</strong>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 font-weight-100">{item.value}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='col-md-2 padding-0-40'>
                            <div className="row">
                                {[
                                  
                                    {
                                        label: 'Team Lead Assigned',
                                        value: payoutCriteriaDetail?.tl_assigned ?? '--',
                                    },
    
                                    {
                                        label: 'Associate Days on Scorecards',
                                        value: payoutCriteriaDetail?.total_associate_days ?? '--',
                                    },
                                ].map((item) => (
                                   <div className="col-md-12 padding-5" key={item.label}>
                                        <div className="row">
                                            <div className="qualifier-label col-md-12">
                                                <strong>{item.label}</strong>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 font-weight-100">{item.value}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            <MessageInfo title="" message="No Payout Details found." rowHeight="50px" />
        </div>
    );
};
